import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { setNotification } from "features/Notification/notificationSlice";
import API from "services/axios";
import authHeader from "services/auth-header";
import ReactQuill from "react-quill";
import ImageWIthSignedUrl from "components/S3Utility/ImageWIthSignedUrl";
import { useSearchParams } from "react-router-dom";
import GeneralDataSizes from "./GeneralDataSizes";
import { Modal } from "react-bootstrap";
import SProductLookUp from "./SProductLookUp";
import Spinner from "components/Spinner";
import { v4 as uuid } from "uuid";

function GeneralDetails({
  generalData,
  setGeneralData,
  updateFunc,
  isViewOnly,
}) {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  /*   ALL STATES
   ********************************************* */
  const [productTypes, setProductTypes] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const [showLockupForm, setShowLockupForm] = useState(null);

  const [loading, setLoading] = useState(false);
  const [fabrics, setFabrics] = useState([]);

  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["clean"],
    ],
  };

  /*   ALL FUNCTIONS
   ********************************************* */
  // get All ProductTypes
  const getAllProductTypes = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/productTypes", {
        headers: authHeader(),
      });
      setProductTypes(data);
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // get All Fabrics
  const getFabrics = async () => {
    try {
      setLoading(true);

      let page = 1;
      let limit = 999;
      let query = "";
      let filterBy = "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post("sales/products/fabrics", body, {
        headers: authHeader(),
      });

      if (data.success) {
        setFabrics(data.data);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const updateGeneralData = (data) => {
    let totalQuantity = 0;
    let totalPrice = 0;

    data.map((item) => {
      totalPrice +=
        parseFloat(item.price).toFixed(2) *
        parseFloat(item.quantity).toFixed(2);
      totalQuantity += parseInt(item.quantity);
    });
    let updatedGeneralData = {
      ...generalData,
      productSizes: JSON.stringify(data),
      totalPrice,
      totalQuantity,
    };
    setGeneralData(updatedGeneralData);
    return updatedGeneralData;
  };

  const addSizesFromProduct = (product) => {
    // Get sizes from the product
    const productSizes = product.sizesWithNames || [];

    // Create new size entries for each size in the product
    const newSizes = productSizes.map((sizeName, index) => {
      return {
        size: sizeName,
        quantity: "0",
        price: "0",
        cost: 0,
        id: uuid(),
        sortId: index + 1,
      };
    });

    // Sort by sortId
    newSizes.sort((a, b) => a.sortId - b.sortId);

    // Return the JSON string of the new sizes array
    return JSON.stringify(newSizes);
  };

  const handleSelectedProduct = (product) => {
    let _productSizes = addSizesFromProduct(product);

    let _productFabric = fabrics?.find(
      (fabric) => fabric.fabricId === product.fabricId
    );
    _productFabric = _productFabric ? _productFabric.name : "";

    let _generalData = {
      ...generalData,
      productStyle: product.styleId,
      productDescription: product.desc,
      productType: product.productType?.productTypes,
      productSizes: _productSizes,
      productFabric: _productFabric,
      productUrl: product.productUrl || "",
    };
    setGeneralData((prev) => _generalData);
    setShowLockupForm(false);
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      getAllProductTypes();
      getFabrics();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  const getBase64Image = async (e) => {
    const file = e.target.files[0];

    // const MAX_FILE_SIZE = 300 * 1024; // 800 KB in bytes
    // if (!["image/jpeg", "image/png"].includes(file.type)) {
    //   alert("Only JPG and PNG image files are allowed.");
    //   e.target.value = "";
    //   return;
    // }
    // if (file.size > MAX_FILE_SIZE) {
    //   alert(`File size exceeds limit (300 KB). Please select a smaller file.`);
    //   e.target.value = "";
    //   return;
    // }

    setGeneralData((prev) => {
      return { ...prev, file };
    });
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPreviewImage(reader?.result);
    };
  };

  useEffect(() => {
    setPreviewImage(null);
  }, [searchParams]);

  return (
    <fieldset disabled={loading}>
      {JSON.stringify(
        generalData?.productImage
          ?.split("?")[0]
          ?.replaceAll("%20", " ")
          ?.replaceAll("%26", " ")
      )}
      {loading && <Spinner />}
      <div className="d-flex">
        {/*   Left Panel
         ********************************************* */}
        <div
          className=" bg-white shadow-lg p-2 w-50  mb-2 me-2"
          style={{ borderRadius: 15 }}
        >
          <div className=" p-1">
            <div className="row mb-1">
              <label className="col-5">Product Type</label>
              <div className="col-7">
                <select
                  disabled={isViewOnly}
                  onChange={(e) =>
                    setGeneralData({
                      ...generalData,
                      productType: e.target.value,
                    })
                  }
                  value={generalData?.productType || ""}
                  className="form-select"
                  id="commision_type"
                  required
                >
                  <option value={""}>Select Product Type</option>
                  {productTypes &&
                    productTypes.map((productType, i) => (
                      <option key={i} value={productType.productTypes}>
                        {productType.productTypes}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="row mb-1">
              <label className="col-5">Product Style</label>
              <div className="col-7 d-flex align-items-center">
                <div className="input-group">
                  <button
                    onClick={() => {
                      setShowLockupForm(true);
                    }}
                    type="button"
                    className="btn btn-sm btn-info"
                  >
                    L
                  </button>
                  <input
                    type="text"
                    className="form-control"
                    required
                    readOnly={isViewOnly}
                    value={generalData?.productStyle}
                    onChange={(e) =>
                      setGeneralData({
                        ...generalData,
                        productStyle: e.target.value,
                      })
                    }
                    placeholder="Enter product style"
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <label className="col-5">Product Description</label>
              <div className="col-7 ">
                <input
                  type="text"
                  readOnly={isViewOnly}
                  value={generalData?.productDescription}
                  onChange={(e) =>
                    setGeneralData({
                      ...generalData,
                      productDescription: e.target.value,
                    })
                  }
                  className="form-control"
                  placeholder="Product description"
                />
              </div>
            </div>
            <div className="row mb-1">
              <label className="col-5">Product Fabric</label>
              <div className="col-7 ">
                {/* products select */}
                <select
                  disabled={loading || isViewOnly}
                  onChange={(e) =>
                    setGeneralData({
                      ...generalData,
                      productFabric: e.target.value,
                    })
                  }
                  value={generalData?.productFabric || ""}
                  className="form-select"
                  id="product_fabric"
                  required
                >
                  <option value={""}>Select Product Fabric</option>
                  {fabrics &&
                    fabrics.map((fabric, i) => (
                      <option key={i} value={fabric.name}>
                        {fabric.name}
                      </option>
                    ))}
                </select>

                {/* <input
                  type="text"
                  readOnly={isViewOnly}
                  value={generalData?.productFabric}
                  onChange={(e) =>
                    setGeneralData({
                      ...generalData,
                      productFabric: e.target.value,
                    })
                  }
                  className="form-control"
                  placeholder="Product fabric"
                /> */}
              </div>
            </div>
            <div className="row mb-1">
              <label className="col-5">Product Color</label>
              <div className="col-7 ">
                <input
                  type="text"
                  readOnly={isViewOnly}
                  value={generalData?.productColor}
                  onChange={(e) =>
                    setGeneralData({
                      ...generalData,
                      productColor: e.target.value,
                    })
                  }
                  className="form-control"
                  placeholder="Product color"
                />
              </div>
            </div>

            <div className="row mb-1">
              <label className="col-5">Team Name</label>
              <div className="col-7 ">
                <input
                  type="text"
                  readOnly={isViewOnly}
                  value={generalData?.teamName || ""}
                  onChange={(e) =>
                    setGeneralData({
                      ...generalData,
                      teamName: e.target.value,
                    })
                  }
                  className="form-control"
                  placeholder="Team Name"
                />
              </div>
            </div>
            <div className="row mb-1">
              <label className="col-5">Product Url</label>

              <div className="col-7 ">
                <div className="input-group">
                  <a
                    href={
                      generalData?.productUrl
                        ? generalData?.productUrl?.startsWith("https")
                          ? `${generalData?.productUrl}`
                          : generalData?.productUrl.startsWith("http")
                          ? generalData?.productUrl
                          : `https://${generalData?.productUrl}`
                        : "#"
                    }
                    disabled={!generalData?.productUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-info flex-center"
                  >
                    U
                  </a>
                  <input
                    type="text"
                    readOnly={isViewOnly}
                    value={generalData?.productUrl || ""}
                    onChange={(e) =>
                      setGeneralData({
                        ...generalData,
                        productUrl: e.target.value,
                      })
                    }
                    className="form-control"
                    placeholder="Product Url"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/*   Right Panel
         ********************************************* */}
        <GeneralDataSizes
          generalData={generalData}
          updateGeneralData={updateGeneralData}
          updateFunc={updateFunc}
          isViewOnly={isViewOnly}
        />
      </div>

      {/* Bottom Pane */}
      <div className="d-flex">
        {/*   Image select
         ********************************************* */}
        <div
          className="bg-white shadow-lg p-2 w-50 mb-2 me-2 d-flex flex-column justify-content-between "
          style={{ borderRadius: 15, minHeight: 300 }}
        >
          {generalData?.productImage && !previewImage ? (
            <ImageWIthSignedUrl
              imgStyle={{
                width: 500,
                height: 300,
              }}
              imgClasses="mb-2"
              path={generalData?.productImage}
              alt="Image"
            />
          ) : (
            <div className="fs-3 text-muted  text-center my-auto">
              {!previewImage && "NO Image Selected"}
            </div>
          )}

          {!generalData?.productImage && previewImage && (
            <img width={500} height={300} src={previewImage} alt="preview" />
          )}

          {generalData?.productImage ? (
            <button
              onClick={() => {
                setPreviewImage(null);
                setGeneralData((prev) => {
                  return { ...prev, productImage: null };
                });
              }}
              type="button"
              disabled={isViewOnly}
              className="btn btn-sm btn-danger"
            >
              Delete Image
            </button>
          ) : (
            <div className="">
              <input
                onChange={getBase64Image}
                type="file"
                className="form-control"
              />
            </div>
          )}
        </div>

        {/*   Notes
         ********************************************* */}
        <div
          className="bg-white shadow-lg p-2 w-50 mb-2 me-2 d-flex flex-column justify-content-between "
          style={{ borderRadius: 15, minHeight: 300 }}
        >
          <div className="">
            <ReactQuill
              modules={modules}
              theme="snow"
              value={generalData?.notes}
              onChange={(val) => setGeneralData({ ...generalData, notes: val })}
            />
          </div>
        </div>
      </div>
      <Modal
        show={showLockupForm}
        onHide={() => setShowLockupForm(false)}
        centered
        size="lg"
        // backdrop="static"
        // keyboard={false}
        contentClassName="bg-white custom-shadow-sm custom-border-radius"
      >
        <Modal.Body>
          <h3 className="">Select Product</h3>
          <hr className="mt-0 mb-3" />
          <SProductLookUp
            handleSelectedProduct={handleSelectedProduct}
            formData={generalData}
            isShowModal={showLockupForm}
          />
          <div className="text-end">
            <button
              onClick={() => setShowLockupForm(false)}
              type="button"
              className="btn btn-sm btn-secondary mt-2"
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </fieldset>
  );
}

export default GeneralDetails;
